import { useEffect, useMemo, useState } from 'react';
import AppHeader from '../../components/AppHeader';
import { authApi, chaptersApi } from '../../api';
import { ROLE_LABELS, useAuth } from '../../contexts/MemberAuthContext';
import SkillPicker, { SkillBadges } from '../../components/SkillPicker';

export default function MembersAdmin() {
  const { member } = useAuth();
  const isSuper = member?.role === 'superadmin';
  const [members, setMembers] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [error, setError] = useState('');
  const [filter, setFilter] = useState([]); // schopnosti, podle kterých filtrovat (AND)

  const load = () => authApi.members().then((r) => setMembers(r.data)).catch(() => {});
  useEffect(() => {
    load();
    chaptersApi.list().then((r) => setChapters(r.data)).catch(() => {});
  }, []);

  const changeRole = async (m, role, chapterId) => {
    setError('');
    try { await authApi.setRole(m.id, role, chapterId || null); load(); }
    catch (err) { setError(err.response?.data?.error || 'Změna selhala.'); }
  };

  const remove = async (id) => {
    setError('');
    if (!confirm('Smazat člena?')) return;
    try { await authApi.deleteMember(id); load(); }
    catch (err) { setError(err.response?.data?.error || 'Smazání selhalo.'); }
  };

  const chapterName = (id) => chapters.find((c) => c.id === id)?.name || '—';

  // Filtr: člen musí mít VŠECHNY vybrané schopnosti.
  const shown = useMemo(() => {
    if (filter.length === 0) return members;
    return members.filter((m) => filter.every((s) => (m.skills || []).includes(s)));
  }, [members, filter]);

  return (
    <div>
      <AppHeader subtitle="Členové" />
      <div className="container-wide" style={{ paddingTop: 24 }}>
        {error && <div className="alert alert-warning mb-16">{error}</div>}

        <div className="card">
          <h3 className="mb-8">Filtr podle schopností</h3>
          <p className="text-muted mb-16" style={{ fontSize: '0.85rem' }}>
            Vyberte schopnosti – zobrazí se jen členové, kteří mají všechny vybrané.
          </p>
          <SkillPicker value={filter} onChange={setFilter} compact />
          <div className="text-muted mt-16" style={{ fontSize: '0.85rem' }}>
            Zobrazeno {shown.length} z {members.length} členů
            {filter.length > 0 && (
              <button className="btn btn-outline btn-sm" style={{ marginLeft: 12 }} onClick={() => setFilter([])}>
                Zrušit filtr
              </button>
            )}
          </div>
        </div>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Jméno</th><th>E-mail</th><th>Schopnosti</th><th>Role</th><th>Spolek</th>
                {isSuper && <th></th>}
              </tr>
            </thead>
            <tbody>
              {shown.map((m) => (
                <tr key={m.id}>
                  <td>{m.first_name} {m.last_name}</td>
                  <td className="text-muted" style={{ fontSize: '0.85rem' }}>{m.email}</td>
                  <td><SkillBadges skills={m.skills} /></td>
                  <td>
                    {isSuper ? (
                      <select className="form-input" style={{ minWidth: 150 }} value={m.role}
                        onChange={(e) => changeRole(m, e.target.value, m.chapter_id)}>
                        {Object.entries(ROLE_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                      </select>
                    ) : (ROLE_LABELS[m.role] || m.role)}
                  </td>
                  <td>
                    {isSuper ? (
                      <select className="form-input" style={{ minWidth: 160 }} value={m.chapter_id || ''}
                        onChange={(e) => changeRole(m, m.role, e.target.value)}>
                        <option value="">— bez spolku —</option>
                        {chapters.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
                      </select>
                    ) : (m.chapter_name || chapterName(m.chapter_id))}
                  </td>
                  {isSuper && <td><button className="btn btn-danger btn-sm" onClick={() => remove(m.id)}>Smazat</button></td>}
                </tr>
              ))}
              {shown.length === 0 && (
                <tr><td colSpan={isSuper ? 6 : 5} className="text-muted text-center">
                  {members.length === 0 ? 'Žádní členové.' : 'Žádný člen nevyhovuje filtru.'}
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
